// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var SlideType;
(function (SlideType) {
    SlideType["SLIDE_TYPE_UNSPECIFIED"] = "SLIDE_TYPE_UNSPECIFIED";
    SlideType["SLIDE_TYPE_CALLS_DURATION"] = "SLIDE_TYPE_CALLS_DURATION";
    SlideType["SLIDE_TYPE_CALLS_OUTBOUND"] = "SLIDE_TYPE_CALLS_OUTBOUND";
    SlideType["SLIDE_TYPE_CALLS_INBOUND_ANSWERED"] = "SLIDE_TYPE_CALLS_INBOUND_ANSWERED";
    SlideType["SLIDE_TYPE_SMS_SENT"] = "SLIDE_TYPE_SMS_SENT";
    SlideType["SLIDE_TYPE_PAYMENTS_PROCESSED"] = "SLIDE_TYPE_PAYMENTS_PROCESSED";
    SlideType["SLIDE_TYPE_FORMS_RECEIVED"] = "SLIDE_TYPE_FORMS_RECEIVED";
})(SlideType || (SlideType = {}));
export var SlideType_index;
(function (SlideType_index) {
    SlideType_index[SlideType_index["SLIDE_TYPE_UNSPECIFIED"] = 0] = "SLIDE_TYPE_UNSPECIFIED";
    SlideType_index[SlideType_index["SLIDE_TYPE_CALLS_DURATION"] = 1] = "SLIDE_TYPE_CALLS_DURATION";
    SlideType_index[SlideType_index["SLIDE_TYPE_CALLS_OUTBOUND"] = 2] = "SLIDE_TYPE_CALLS_OUTBOUND";
    SlideType_index[SlideType_index["SLIDE_TYPE_CALLS_INBOUND_ANSWERED"] = 3] = "SLIDE_TYPE_CALLS_INBOUND_ANSWERED";
    SlideType_index[SlideType_index["SLIDE_TYPE_SMS_SENT"] = 4] = "SLIDE_TYPE_SMS_SENT";
    SlideType_index[SlideType_index["SLIDE_TYPE_PAYMENTS_PROCESSED"] = 5] = "SLIDE_TYPE_PAYMENTS_PROCESSED";
    SlideType_index[SlideType_index["SLIDE_TYPE_FORMS_RECEIVED"] = 6] = "SLIDE_TYPE_FORMS_RECEIVED";
})(SlideType_index || (SlideType_index = {}));
/**
 *
 * Service for the Threads of Success (aka weave-wraps) API.
 */
export const API = {
    /**
     *
     * GetSlides returns a list of slides to display on the Threads of Success panel.
     * @param GetSlidesRequest The request message containing the locationIDs to get slides for.
     * @return GetSlidesResponse The response message containing the slides to display.
     */
    GetSlides(fn, req) {
        return fn(`/threads-of-success/v1/slides?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
